export const LIST_USERS_REQ = "listUsersReq";
export const LIST_USERS_SUCCESS = "listUsersSuccess";
export const LIST_USERS_FAILED = "listUsersFailed";
